// One base for every caller (ADR-002). The server reads it from its
// environment; the browser receives it through the root loader's config and
// the root component sets it here before anything under it can fetch.
let browserBase: string | undefined;

export function setApiBase(origin: string): void {
  browserBase = origin;
}

const apiBase = (): string => {
  if (typeof window === "undefined") {
    return process.env.API_ORIGIN ?? "http://localhost:8080";
  }
  if (!browserBase) {
    // Loud rather than a fallback: a fetch that runs before the root renders
    // (a hydrate-time clientLoader) then fails on the first local run instead
    // of calling the wrong origin only once deployed.
    throw new Error("API base read before the root component set it");
  }
  return browserBase;
};

type QueryParams = Record<string, string>;

const constructUrl = (path: string, queryParams?: QueryParams): URL => {
  const url = new URL(`${apiBase()}${path}`);
  if (queryParams) {
    url.search = new URLSearchParams(queryParams).toString();
  }
  return url;
};

export const apiConfig = {
  content: {
    list: (queryParams?: QueryParams) => constructUrl("/content", queryParams),
    byIdOrSlug: (idOrSlug: string, queryParams?: QueryParams) =>
      constructUrl(`/content/${idOrSlug}`, queryParams),
  },
  compilations: {
    list: (queryParams?: QueryParams) =>
      constructUrl("/compilations", queryParams),
    byId: (id: string, queryParams?: QueryParams) =>
      constructUrl(`/compilations/${id}`, queryParams),
  },
  highlights: {
    list: (queryParams?: QueryParams) =>
      constructUrl("/highlights", queryParams),
    byId: (id: string, queryParams?: QueryParams) =>
      constructUrl(`/highlights/${id}`, queryParams),
  },
};
